import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { loadPresClubRevenue, loadPresClubUtilization } from "../../../redux/actions/PresClubActions";
import RevenueLeaders from "../RevenueLeaders";
import UtilizationLeaders from "../UtilizationLeaders";
import Information from "../../common/alerts/Information";
import DashboardPanel from "./DashboardPanel";

class DashboardPage extends React.Component {
  render() {
    return (
      <Container fluid>
        
        {!this.state.revLoading && !this.state.utilLoading ?
            this.props.localRevDetails.isUserLeaderboardVisible ?
              <Row className="justify-content-center">
                <Col lg="4">
                  <RevenueLeaders data={this.props.localRevDetails} isAdmin={false} />
                </Col>
                <Col lg="4">
                  <UtilizationLeaders data={this.props.localUtilDetails} isAdmin={false} />
                </Col>
              </Row>              
              : <Row>
                  <div style={{ marginTop: "25px", marginLeft: "125px", marginRight: "125px" }}>
                    <DashboardPanel>
                      President's Club leaderboards have been turned 
                      off for the remainder of the year. Good luck!                      
                    </DashboardPanel>
                  </div>
                </Row>
          : <Row><div></div></Row>
        }

        <Row>
        <div style={{ marginTop: "25px", marginLeft: "125px", marginRight: "125px" }}>
          <Information title="Notes">

            <p><strong>This reward and recognition program honors those employees who make the most 
              significant contributions to the company each year.</strong></p>

            <p>The President’s Club is open to all employees in all roles and at all levels 
            of the organization. Each year, a new group of employees will be selected based on their 
            contributions during RBA’s fiscal year.</p>

            <p>Employees make the Presidents Club in one of five ways:</p>
            <p>
              <ul>
              <li>Top for billable hours for the year</li>
              <li>Top revenue generated for the year</li>
              <li>Star of Excellence award</li>
              <li>Executive selection</li>
              <li>Management\Sales Quotas </li> 
              </ul>              
            </p>

            <p>Everyone part of the Presidents Club will be included on a celebration 
              trip and receive additional RBA stock options.</p>

            <p>*Presidents Club trips are for employees only.</p>
            
          </Information>
           </div>         
        </Row>
 
      </Container>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      ghost: null,
      revLoading: true,
      utilLoading: true,
    };
  }

  componentDidMount() {
    this.props.loadPresClubRevenue(this.props.localProfile.isAdmin ? this.props.localProfile.ghost : null)
    .then(() => {
      this.setState({revLoading: false})
    })
    .catch((error) => {
      alert("Revenue Leaders did not load: " + error);
    });

    this.props.loadPresClubUtilization(this.props.localProfile.isAdmin ? this.props.localProfile.ghost : null)
    .then(() => {
      this.setState({utilLoading: false})
    })
    .catch((error) => {
      alert("Utilization Leaders did not load: " + error);
    });

    this.setState({
      ghost: this.props.localProfile.ghost,
    });
  }

  componentDidUpdate() {
    if (this.props.localProfile.ghost !== this.state.ghost) {
      this.setState({revLoading: true});
      this.props.loadPresClubRevenue(this.props.localProfile.isAdmin ? this.props.localProfile.ghost : null)
        .then(() => this.setState({revLoading: false}))
        .catch((error) => {
          alert("Revenue Leaders did not load: " + error);
          this.setState({revLoading: false});
        });

      this.setState({utilLoading: true});
      this.props.loadPresClubUtilization(this.props.localProfile.isAdmin ? this.props.localProfile.ghost : null)
        .then(() => this.setState({utilLoading: false}))
        .catch((error) => {
          alert("Utilization Leaders did not load: " + error);
          this.setState({utilLoading: false})
        });

      this.setState({ ghost: this.props.localProfile.ghost });
    }
  }
}

function mapStateToProps(state, ownProps) { 
  return {
    localRevDetails: state.presClubDetails.revDetails,
    localUtilDetails: state.presClubDetails.utilDetails,
    localProfile: state.profile,
  };
}

const mapDispatchToProps = {
  loadPresClubRevenue,
  loadPresClubUtilization
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);